/**
 * After UI deploy, open tabs may reference deleted lazy chunks. Reload once per session.
 */
const RELOAD_FLAG = "ead-expui.stale-chunk-reload.v1";

export function shouldReloadStaleChunk(message: string): boolean {
  const lower = String(message || "").toLowerCase();
  return lower.includes("failed to fetch dynamically imported module")
    || lower.includes("importing a module script failed");
}

export function installStaleChunkReloadGuard(): void {
  if (typeof window === "undefined") return;

  const reloadOnce = (message: string): void => {
    if (!shouldReloadStaleChunk(message)) return;
    try {
      if (sessionStorage.getItem(RELOAD_FLAG) === "1") return;
      sessionStorage.setItem(RELOAD_FLAG, "1");
      window.location.reload();
    } catch {
      window.location.reload();
    }
  };

  window.addEventListener("error", (event) => {
    reloadOnce(String((event as ErrorEvent).message || ""));
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message =
      reason instanceof Error
        ? reason.message
        : typeof reason === "string"
          ? reason
          : String(reason || "");
    reloadOnce(message);
  });
}
